import React from "react";

const BASE = "https://media.base44.com/images/public/6ab7c499b9f1892aef65dca6";

// Each company's own mark. The three that came in as flat coloured squares
// (Avis, Sixt, Hertz) are used edge to edge; the rest are drawn on white.
// Target, Budget and Hertz were rebuilt into clean square versions so every
// tile in the rail reads at the same weight.
export const RENTAL_LOGOS = {
  "Charlie Car Rental": `${BASE}/f1539136c_image.png`,
  "Target Rent a Car": `${BASE}/ec914ad7d_generated_image.png`,
  Avis: `${BASE}/a1a512687_image.png`,
  Sixt: `${BASE}/785b6ba86_image.png`,
  Enterprise: `${BASE}/06296a878_image.png`,
  Hertz: `${BASE}/4c4480fb2_generated_image.png`,
  Budget: `${BASE}/fc71d161e_generated_image.png`,
};

/**
 * A rental company's own mark on a white plate. The plate carries the size, and
 * the logo fills as much of it as its own proportions allow, so a wide wordmark
 * and a square badge both read at the same weight instead of shrinking into the
 * middle of the card. Companies still without artwork fall back to their mark.
 */
export default function RentalLogo({ company, className = "", imgClassName = "h-full w-full" }) {
  if (!company.logo) {
    return (
      <span
        aria-hidden="true"
        className={`flex items-center justify-center rounded-[8px] bg-[#f4f2ec] text-[22px] font-black text-[#171717] dark:bg-white/[0.07] dark:text-[#f2efe9] ${className}`}
      >
        {company.mark}
      </span>
    );
  }

  return (
    <span
      className={`flex items-center justify-center overflow-hidden rounded-[8px] border border-black/[0.08] bg-white p-2 ${className}`}
    >
      <img
        src={company.logo}
        alt={`${company.name} logo`}
        loading="lazy"
        decoding="async"
        className={`shrink-0 object-contain ${imgClassName}`}
      />
    </span>
  );
}